import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_tareas_actividades(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_tareaactividad",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_casos_asig_liq(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_casosasigsininf",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_cantidad_pagos_ejecutivo(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_cargadetrabajo",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_siniporpoliza(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_siniporpoliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_siniactconinf(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_siniactconinf",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
	
	pre_insercion_sinicobdirecta(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_sinicobdirecta",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	pre_insercion_totaltareaactiv(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_totaltareaactiv",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	pre_insercion_consolidadoindem(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_consolidadoindem",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	pre_insercion_ctrlgestion_area(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.pre_insercion_ctrlgestion_area",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	InformeAvisoImpagoEjecutivo(p_email, p_usuario, p_anio, p_ejecutivo, p_origenpro, p_selected) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_avisoimpago",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_anio": p_anio,
                    "p_ejecutivo": p_ejecutivo,
					"p_origenpro": p_origenpro,
					"p_selected": p_selected
				  })
			})
	},
	
	InformeTiemposPromedioGestion(p_email, p_usuario, p_anio, p_ejecutivo, p_origenpro, p_selected) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_tiemprogestion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_anio": p_anio,
					"p_ejecutivo": p_ejecutivo,
					"p_selected": p_selected,
					"p_origenpro": p_origenpro
				  })
			})
	},
	
	InformeCasosActivosSinCobradorLiquidadorEjecutivo(p_email, p_usuario, p_anio, p_ejecutivo, p_origenpro, p_selected) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_sini_sin_asignar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_anio": p_anio,
					"p_ejecutivo": p_ejecutivo,
					"p_selected": p_selected,
					"p_origenpro": p_origenpro
				  })
			})
	},
	
	InformeTareasActividades(p_email, p_usuario, p_desde, p_hasta, p_ejecutivo, p_asistente) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_tareaactividad",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fdesde": p_desde,
					"p_fhasta" : p_hasta,
					"p_ejecutivo": p_ejecutivo,
					"p_asistente": p_asistente
				  })
			})
	},

	CasosAsignadosaLiquidadorsinInformedeLiquidacion(p_email, p_usuario, p_selected, p_desde, p_hasta, p_ejecutivo, p_producto, p_origpro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_casosasigsininf",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_selected": p_selected,
					"p_fdesde": p_desde,
					"p_fhasta" : p_hasta,
					"p_ejecutivo": p_ejecutivo,
					"p_producto": p_producto,
					"p_origpro": p_origpro
				  })
			})
	},

	CargaDeTrabajoCantidadDePagosPorEjecutivo(p_email, p_usuario, p_anio, p_ejecutivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_cargadetrabajo",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_anio": p_anio,
					"p_ejecutivo": p_ejecutivo
				})
			})
	},


	siniporpoliza(p_email, p_usuario, p_poliza, p_fdesde, p_fhasta, p_origenpro, p_selected) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_siniporpoliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_fdesde": p_fdesde,
					"p_fhasta": p_fhasta,
					"p_origenpro": p_origenpro,
					"p_selected": p_selected
				})
			})
	},

	recuperar_siniactconinf(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_siniactconinf",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				})
			})
	},

	recuperar_sinicobdirecta(p_email, p_usuario, p_ejecutivo, p_poliza, p_fdesde, p_fhasta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_sinicobdirecta",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo,
					"p_poliza": p_poliza,
					"p_fdesde": p_fdesde,
					"p_fhasta": p_fhasta
				})
			})
	},

	recuperar_totaltareaactiv(p_email, p_usuario, p_fdesde, p_fhasta, p_tareas) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_totaltareaactiv",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fdesde": p_fdesde,
					"p_fhasta": p_fhasta,
					"p_tareas": p_tareas
				})
			})
	},

	recuperar_consolidadoindem(p_email, p_usuario, p_fdesde, p_fhasta, p_moneda) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_consolidadoindem",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fdesde": p_fdesde,
					"p_fhasta": p_fhasta,
					"p_moneda": p_moneda
				})
			})
	},

	recuperar_ctrlgestion_area(p_email, p_usuario, p_fecha) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "PKG_SINPP_INFORMES.recuperar_ctrlgestion_area",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha
				})
			})
	},
}